import i18n from '../../locales/i18n'
import { LanguageCodes } from './languages'

export enum WeightTypes {
  LBS = 'lb',
  LB_OUNCES = 'lb_ounces',
  KG = 'kg',
}

export const LocalizedWeightMap = {
  [LanguageCodes['ca-ES']]: WeightTypes.KG,
  [LanguageCodes['es-ES']]: WeightTypes.KG,
  [LanguageCodes['pt-PT']]: WeightTypes.KG,
  [LanguageCodes['pt-BR']]: WeightTypes.KG,
  [LanguageCodes['en-US']]: WeightTypes.LBS,
}

export enum TemperatureTypes {
  F = '°F',
  C = '°C',
}

export const LocalizedTemperatureMap = {
  [LanguageCodes['ca-ES']]: TemperatureTypes.C,
  [LanguageCodes['es-ES']]: TemperatureTypes.C,
  [LanguageCodes['pt-PT']]: TemperatureTypes.C,
  [LanguageCodes['pt-BR']]: TemperatureTypes.C,
  [LanguageCodes['en-US']]: TemperatureTypes.F,
}

export enum UnitTypes {
  WEIGHT = 'weight',
  TEMPERATURE = 'temperature',
  BEATS_PER_MINUTE = 'beatsPerMinute',
  BREATHS_PER_MINUTE = 'breathsPerMinute',
  MILLIMETRE_OF_MERCURY = 'millimetreOfMercury',
  PERCENT = 'percent',
  LITRES_PER_MINUTE = 'litresPerMinute',
  MUSCLE_MASS_SCORE = 'muscleMassScore',
}

export const UnitTypesLabelMap = {
  [UnitTypes.BEATS_PER_MINUTE]: i18n.t('Abbreviations:UNITS.BEATS_PER_MINUTE'),
  [UnitTypes.BREATHS_PER_MINUTE]: i18n.t(
    'Abbreviations:UNITS.BREATHS_PER_MINUTE',
  ),
  [UnitTypes.MILLIMETRE_OF_MERCURY]: i18n.t(
    'Abbreviations:UNITS.MILLIMETRE_OF_MERCURY',
  ),
  [UnitTypes.PERCENT]: i18n.t('Abbreviations:UNITS.PERCENT'),
  [UnitTypes.LITRES_PER_MINUTE]: i18n.t(
    'Abbreviations:UNITS.LITRES_PER_MINUTE',
  ),
}
